import { useContext } from 'react'

import { type GroupContext, groupContext } from '../providers/GroupProvider'

export const useGroup = (): GroupContext => useContext(groupContext)
